import React from 'react';

interface PromptBannerProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    onClose: () => void;
    dismissLabel: string;
    actionLabel: string;
    onAction?: () => void;
    actionHref?: string;
    loading?: boolean;
}

export default function PromptBanner({
    icon,
    title,
    description,
    onClose,
    dismissLabel,
    actionLabel,
    onAction,
    actionHref,
    loading,
}: PromptBannerProps) {
    const handleClose = () => {
        console.log('[PromptBanner] onClose clicked');
        onClose();
    };

    const handleAction = () => {
        console.log('[PromptBanner] onAction clicked');
        onAction?.();
    };
    return (
        <div className="fixed inset-0 z-[9999] flex items-end sm:items-start justify-center bg-black/15 p-4">
            <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-lg max-w-md w-full">
                <div className="flex items-start gap-3">
                    <div className="flex-shrink-0">{icon}</div>
                    <div className="flex-1 min-w-0">
                        <h3 className="text-gray-800 font-semibold text-sm sm:text-base">{title}</h3>
                        <p className="text-gray-500 text-xs sm:text-sm mt-1">{description}</p>
                    </div>
                    <button
                        onClick={handleClose}
                        disabled={loading}
                        className="flex-shrink-0 text-gray-400 hover:text-gray-600 p-1 bg-transparent border-none cursor-pointer disabled:opacity-50"
                        aria-label="Cerrar"
                    >
                        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>

                <div className="mt-3 flex gap-2">
                    <button
                        onClick={handleClose}
                        disabled={loading}
                        className="flex-1 px-3 py-2 text-sm text-gray-500 hover:text-gray-800 transition-colors bg-transparent border-none cursor-pointer disabled:opacity-50"
                    >
                        {dismissLabel}
                    </button>
                    {actionHref ? (
                        <a
                            href={actionHref}
                            className="flex-1 px-3 py-2 text-sm bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors border-none cursor-pointer text-center no-underline"
                        >
                            {actionLabel}
                        </a>
                    ) : (
                        <button
                            onClick={handleAction}
                            disabled={loading}
                            className="flex-1 px-3 py-2 text-sm bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors border-none cursor-pointer disabled:opacity-50"
                        >
                            {actionLabel}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
